/*
| How a rate-limited page recovers: one automatic retry at the server's
| Retry-After horizon per navigation, then it waits for the reader. Another
| client behind the same IP can keep the limiter drained, and a page that kept
| retrying on its own would keep spending that shared budget.
*/

export function createRetryPolicy() {
  let available = true;

  return {
    /** Every render: a navigation or reload restores the allowance, a retry does not. */
    startRender({ isRetry = false } = {}) {
      if (!isRetry) available = true;
    },

    /** True once per navigation: the caller may schedule its one retry. */
    takeRetry() {
      if (!available) return false;
      available = false;
      return true;
    },
  };
}
